import { useMaxMonthly } from '~/context/home/FinanceContext';
import CashIcon from '~/icons/CashIcon';
import { nativeTermsPayload } from '~/native/home/utils';
import {
  MainContentBoldText,
  MainContentHeader,
  StatusPill
} from './DynamicPromoTile.styles';
import {
  getDynamicTilePillText,
  getPillColorScheme,
  TileStatus,
  TileType
} from '../TileUtils';

type OwnProps = {
  tileStatus: TileStatus;
  tileType: TileType;
};

export default function FinancingInfo({ tileStatus, tileType }: OwnProps) {
  const monthlyPayment = useMaxMonthly();
  const pillClassName = getPillColorScheme(tileStatus);
  const pillText = getDynamicTilePillText({ tileStatus, tileType });

  const headerText =
    tileStatus === TileStatus.isActive || tileStatus === TileStatus.isWarning
      ? 'You’re approved for monthly payments up to:'
      : '';

  return (
    <>
      <MainContentHeader>
        <StatusPill className={pillClassName}>{pillText}</StatusPill>
        <MainContentBoldText>{headerText}</MainContentBoldText>
      </MainContentHeader>
      <div className="flex flex-col gap-16">
        <section className="flex items-center justify-between">
          {monthlyPayment > 0 ? (
            <div className="text-[28px] font-semibold leading-[32px] ">
              ${monthlyPayment.toLocaleString()}/mo
            </div>
          ) : (
            <MainContentBoldText>
              Your financing terms expired.
            </MainContentBoldText>
          )}
          <div className="inline-flex items-center rounded-full bg-grey-1 p-12">
            <CashIcon />
          </div>
        </section>
        {tileStatus === TileStatus.isExpired ? (
          <p className="text-sm text-blue-6 m:text-base">
            Refresh to continue shopping with real, personalized payments.{' '}
          </p>
        ) : (
          <a
            href="/financing"
            data-analytics-id="Home feed card"
            data-analytics-attributes={JSON.stringify({
              description: `${tileType} tile terms cta`,
              monthlyPayment
            })}
            data-qa={`${tileType} view my terms link`}
            className="text-sm text-blue-6 underline"
            data-native-payload={nativeTermsPayload}
          >
            View my terms
          </a>
        )}
      </div>
    </>
  );
}
